import React, { useContext, useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";
import { AppContext } from "../../App";


export default function SingleCard(props){

  const { activeUser, setChangesMade } = useContext(AppContext)

  const [selectedFile, setSelectedFile] = useState("")

  const [uploading, setUploading] = useState(false)

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const url = "https://api.cloudinary.com/v1_1/craigycraig/image/upload"

  const fileURL = activeUser.bandDocuments.find(obj => obj.docName === `${props.dbName}`).docURL

  function uploadFile(e){
    setUploading(true)
    const user = localStorage.getItem('user')

    const formData = new FormData()
    formData.append(`file`, selectedFile)
    formData.append('upload_preset', 'oclujvnf')
    formData.append('public_id', `${user}${props.dbName}`)

    fetch(url, {
      method: "POST",
      body: formData
    })
      .then((response) => {
        console.log(response);
      })
      .then(()=>console.log("File successfully uploaded"))
      .then(()=> postURLtoDatabase())
      .then(()=> setUploading(false))
      .then(()=> setSelectedFile(""))
      .then(()=> setChangesMade(prev => prev+1))
    
    console.log(activeUser)
  }

  async function postURLtoDatabase(){
    const databaseURL = [`https://res.cloudinary.com/craigycraig/image/upload/band_documents/${activeUser.username}${props.dbName}`]

    await fetch(`https://the-paper-pusher.herokuapp.com/uploadDocuments/${activeUser.username}/${props.dbName}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(databaseURL)
    })
    .catch(error=>{
      window.alert(error)
      return
    })
  }

  async function removeCurrentFile(e){
    e.preventDefault()
    const emptyStr = [""]

    
    await fetch(`https://the-paper-pusher.herokuapp.com/uploadDocuments/${activeUser.username}/${props.dbName}`,{
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(emptyStr)
    })
    .then(() => handleClose())
    .then(()=> setChangesMade(prev => prev+1))
    .catch(error=>{
      window.alert(error)
      return
    })
  }

  return(

    <Card sx={{ maxWidth: 200 }} elevation={2}>
          
      <Typography sx={{marginTop:'1em', mb: 1.5, marginLeft:'1em', marginRight: '1em' }} color="text.secondary">
        {props.title}
      </Typography>
      {uploading ? 
        <CircularProgress /> : 
        props.icon }
      <CardActions>
        {fileURL != "" ? 
        <div>
          <a href={fileURL} target="_blank" className="view-btn"><Button sx={{fontSize:'0.8em'}} size="small">View</Button></a>
          <Button sx={{fontSize:'0.8em'}} size="small" onClick={handleClickOpen}>Replace</Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Delete and replace existing file:"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete the current {props.title} and upload a different document?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button onClick={removeCurrentFile} autoFocus>
                Yes, I'm sure
              </Button>
            </DialogActions>
          </Dialog>
        </div> : 

        <div>
          <Button sx={{fontSize:'0.8em', color: 'red'}} component="label" size="small" type="file">Upload
          <input onChange={(e)=> setSelectedFile(e.target.files[0])} type={'file'} hidden /></Button>
          <Button disabled={selectedFile === ""} sx={{fontSize:'0.8em'}} size="small" type="file" onClick={uploadFile}>Submit</Button>
        </div>
        
        
        }
      </CardActions>
          
    </Card>
  )}